import { ActionStatus } from '@/application/types';
import { AuthenticationState } from '../types';

export const authenticationStateDefaults: AuthenticationState = {
  isAuthenticated: false,
  user: {
    email: '',
    roles: [],
    enabledFeatures: [],
    isEnabled: false,
  },
  loginStatus: ActionStatus.None,
  logoutStatus: ActionStatus.None,
  fetchAuthenticatedUserStatus: ActionStatus.None,
};
